import { Button, Form, Input } from 'antd';
import { useState } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';
import { RiskCategory } from '../../../models';

export function RiskCategoryEditPage(props: { riskCategory?: RiskCategory; onSaved: () => void }) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values: any) => {
    const body = { ...values };
    if (props.riskCategory) {
      body.id = props.riskCategory.id;
    }

    setLoading(true);
    if (!props.riskCategory) {
      apiClient
        .post(`risk-categories`, body)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      apiClient
        .put(`risk-categories/${props.riskCategory?.id}`, body)
        .then(() => {
          props.onSaved();
        })
        .catch((reason: any) => {
          apiErrorMessage(reason);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish} initialValues={props.riskCategory}>
      <Form.Item
        label="İsim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 200, message: 'En fazla 200 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Gönder
        </Button>
      </Form.Item>
    </Form>
  );
}
